import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useState } from "react";
import { Mail, MapPin, Phone, Send } from "lucide-react";
import CountryPhone from "../components/common/CountryPhone";
import { buildFullPhone, DEFAULT_COUNTRY } from "../lib/countries";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", country: DEFAULT_COUNTRY, message: "" });
  const [loading, setLoading] = useState(false);
  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) return toast.error("Name, email and phone are required.");
    setLoading(true);
    try {
      await api.post("/consultations", {
        ...form,
        phone: buildFullPhone(form.country, form.phone),
        interested_demo: "General enquiry",
      });
      toast.success("Thanks! A StaffLink specialist will be in touch.");
      setForm({ name: "", email: "", phone: "", country: DEFAULT_COUNTRY, message: "" });
    } catch { toast.error("Could not send. Try again."); }
    finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-xs font-semibold uppercase tracking-widest text-primary">Contact</div>
      <h1 className="mt-1 font-display text-3xl sm:text-4xl">Talk to a StaffLink specialist</h1>
      <p className="mt-3 text-muted-foreground max-w-2xl">
        We usually respond within an hour during business hours (Mon–Fri, 08:00–18:00 GMT).
      </p>

      <div className="mt-8 grid md:grid-cols-3 gap-6">
        <div className="md:col-span-1 space-y-3">
          <div className="flex items-center gap-2 text-sm text-muted-foreground"><MapPin className="w-4 h-4"/> Accra, Ghana</div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground"><Phone className="w-4 h-4"/> +233 59 982 7348</div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground"><Mail className="w-4 h-4"/> hello@stafflinkgh.com</div>
        </div>
        <Card className="glass md:col-span-2"><CardContent className="p-6">
          <form onSubmit={submit} className="space-y-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div><Label>Name *</Label><Input value={form.name} onChange={update("name")} data-testid="contact-name"/></div>
              <div><Label>Email *</Label><Input type="email" value={form.email} onChange={update("email")} data-testid="contact-email"/></div>
            </div>
            <div>
              <Label>Phone *</Label>
              <CountryPhone
                testIdPrefix="contact-phone"
                country={form.country}
                phone={form.phone}
                onChange={({ country, phone }) => setForm((f) => ({ ...f, country, phone }))}
              />
            </div>
            <div><Label>Message</Label><Textarea rows={4} value={form.message} onChange={update("message")} data-testid="contact-message"/></div>
            <Button type="submit" disabled={loading} className="w-full h-11" data-testid="contact-submit">
              <Send className="w-4 h-4 mr-2"/> Send message
            </Button>
          </form>
        </CardContent></Card>
      </div>
    </div>
  );
}
